








































































































































































import { Component, Prop, Watch } from "vue-property-decorator";
import BaseVue from "@/core/BaseVue";
import PorposalService from "@/services/porposal.service";
import Evaluacion from "@/models/evaluacion/evaluacion.model";
import { AnswerType } from "@/enums/AsnwerType";
import AnswerUI from "@/models/evaluacion/answerUI.model";
import EvaluationAnswerUI from "@/models/evaluacion/evaluationAnswerUI.model";
import EvaluationUserCompletedUI from "@/models/evaluacion/evaluationUserCompletedUI.model";
import UserEvaluationState from "@/models/evaluacion/userEvaluationStateSelected.Model";
import UserBasicInformationComponent from "@/components/user-basic-information/userBasicInformation.vue";
import User from "@/models/security/user.model";
import { EvaluationState } from "../../enums/EvaluationState";

@Component({
  components: {
    UserBasicInformationComponent
  }
})
export default class ProposalEvaluationComponent extends BaseVue {
  @Prop() public proposalId!: number;
  @Prop() public evaluationTypes!: [] | any;

  loading: boolean = false;
  textbox: AnswerType = AnswerType.TEXTBOX;
  checkbox: AnswerType = AnswerType.CHECKBOX;
  select: AnswerType = AnswerType.SELECT;
  porposalRespository: PorposalService = new PorposalService();
  data: any = null;
  evaluations: Array<EvaluationAnswerUI> = [];


   

  evaluationStateName(evaluationId: number, isApproved: boolean) {
    if (this.evaluationTypes && this.evaluationTypes.length > 0) {
      let evaluationSelected = this.evaluationTypes.find(
        (x: any) => x.evaluationTypeId == evaluationId
      ).evaluationType;
      if (evaluationSelected.expectResult) {
        let approved = evaluationSelected.approvalLabel ? evaluationSelected.approvalLabel.toUpperCase() : "APROBADA";
        let disApproved = evaluationSelected.disapprovalLabel ? evaluationSelected.disapprovalLabel.toUpperCase() : "NO APROBADA";
        return isApproved ? approved : disApproved;
      } else {
        return "REVISADA";
      }
    }
    return "";
  }

  getStateName(state: EvaluationState) {
    let stateName = "";
    switch (state) {
      case EvaluationState.RECOMENDADA:
        stateName = " RECOMENDADA";
        break;
      case EvaluationState.RECOMENDADACONCONDICION:
        stateName = " RECOMENDADA CON CONDICION";
        break;
      case EvaluationState.NORECOMENDADA:
        stateName = " NO RECOMENDADA";
        break;
    }
    return stateName;
  }

  getEvaluationType(evaluationTypes: any[], currentEvaluation: number) {
    return evaluationTypes.find(x => x.evaluationTypeId === currentEvaluation)
      .proporsalUsersEvaluators;
  }

  async mounted() {
    await this.getEvaluations();
  }

  validateMainEvaluationState() {
    let mainEvaluation = this.evaluations.find(x => x.isMainEvaluation);
    let evaluators = this.evaluationTypes.find(
      (x: any) => x.isMainEvaluation
    ) as any;
    if (mainEvaluation) {
      let groupedEvaluations = this.groupBy(
        mainEvaluation.userEvaluationState,
        "evaluationState"
      );
      if (groupedEvaluations && groupedEvaluations.length > 1) {
        let totalEvaluations = 0;
        let maximunEvaluationTypeNumber = 0;
        let requireAnotherEvaluator = true;
        for (let i = 0; i < groupedEvaluations.length; i++) {
          totalEvaluations += groupedEvaluations[i].length;
          if (
            i == 0 ||
            groupedEvaluations[i].length > groupedEvaluations[i - 1].length
          ) {
            maximunEvaluationTypeNumber = groupedEvaluations[i].length;
          }
        }
        requireAnotherEvaluator =
          groupedEvaluations.filter(
            x => x.length == maximunEvaluationTypeNumber
          ).length > 1
            ? true
            : false;
        requireAnotherEvaluator =
          requireAnotherEvaluator &&
          totalEvaluations == evaluators.proporsalUsersEvaluators.length
            ? true
            : false;
        this.$store.commit(
          "set_displayMoreEvaluatorsRequiredAlert",
          requireAnotherEvaluator
        );
      }
    }
  }

  @Watch("evaluationTypes")
  onEvaluationTypeChange(value) {
    if (value && this.evaluations.length > 0) {
      this.validateMainEvaluationState();
    }
  }

  @Watch("evaluations")
  onEvaluationChange(value) {
    if (value && this.evaluationTypes.length > 0) {
      this.validateMainEvaluationState();
    }
  }

  groupBy(collection, property) {
    var i = 0,
      val,
      index,
      values = [],
      result = [];
    for (; i < collection.length; i++) {
      val = collection[i][property];
      index = values.indexOf(val);
      if (index > -1) result[index].push(collection[i]);
      else {
        values.push(val);
        result.push([collection[i]]);
      }
    }
    return result;
  }

  async getEvaluations() {
    if (this.proposalId) {
      this.loading = true;

      this.evaluations = [];
      this.data = null;

      this.data = await this.porposalRespository.getEvaluationsByProposalId(
        this.proposalId
      );
      this.data.evaluaciones.forEach((evaluacion: Evaluacion) => {
        let answers = [];
        let users = this.data.evaluaciones
          .filter(x => x.evaluationTypeId == evaluacion.evaluationType.id)
          .map(x => x.user);

        let questions = evaluacion.evaluationType.preguntas;

        evaluacion.respuestas.forEach(answer => {
          let evaluatorAnswerSelected = new AnswerUI();
          if (
            answer.tipoRespuesta === this.textbox ||
            ((answer.tipoRespuesta === this.checkbox ||
              answer.tipoRespuesta === this.select) &&
              answer.valorBool)
          ) {
            evaluatorAnswerSelected.answerUI = String(answer.valorString);
            evaluatorAnswerSelected.questionId = answer.preguntaId;
            evaluatorAnswerSelected.evaluatorsUI.push(evaluacion.user);
            evaluatorAnswerSelected.answerTypeUI = answer.tipoRespuesta;
          }
          if (
            evaluatorAnswerSelected.questionId != null &&
            evaluatorAnswerSelected.answerUI &&
            evaluatorAnswerSelected.evaluatorsUI
          )
            answers.push(evaluatorAnswerSelected);
        });

        if (
          this.evaluations.length === 0 ||
          (this.evaluations.length > 0 &&
            !this.evaluations.some(
              x => x.evaluationTypeId === evaluacion.evaluationType.id
            ))
        ) {
          let newEvaluationUI = new EvaluationAnswerUI();

          this.data.evaluaciones
            .filter(x => x.evaluationTypeId == evaluacion.evaluationType.id)
            .forEach((evaluacion: Evaluacion) => {
              let evaluationUserCompletedUI = new EvaluationUserCompletedUI();
              evaluationUserCompletedUI.user = evaluacion.user;
              evaluationUserCompletedUI.isCompleted = evaluacion.fueCompletada;
              evaluationUserCompletedUI.motivoEvaluacion =
                evaluacion.motivoEvaluacion;
              newEvaluationUI.evaluationUsers.push(evaluationUserCompletedUI);

              let userEvaluationState = new UserEvaluationState();
              userEvaluationState.evaluationState = evaluacion.evaluationState;
              userEvaluationState.isApproved = evaluacion.isApproved;
              userEvaluationState.evaluator = evaluacion.user;
              newEvaluationUI.userEvaluationState.push(userEvaluationState);
            });

          newEvaluationUI.isMainEvaluation = evaluacion.isMainEvaluation;
          (newEvaluationUI.title = evaluacion.evaluationType.titulo),
            (newEvaluationUI.evaluationTypeId = evaluacion.evaluationType.id),
            (newEvaluationUI.evaluators = users),
            (newEvaluationUI.questions = questions),
            (newEvaluationUI.answers = answers);
          this.evaluations.push(newEvaluationUI);
        } else {
          let evaluation = this.evaluations.find(
            x => x.evaluationTypeId === evaluacion.evaluationType.id
          );
          answers.forEach(newAnswer => {
            if (
              evaluation.answers.some(
                x =>
                  x.answerTypeUI === newAnswer.answerTypeUI &&
                  x.questionId === newAnswer.questionId &&
                  x.answerUI === newAnswer.answerUI
              )
            ) {
              let answer = evaluation.answers.find(
                x =>
                  x.answerTypeUI === newAnswer.answerTypeUI &&
                  x.questionId === newAnswer.questionId &&
                  x.answerUI === newAnswer.answerUI
              );
              answer.evaluatorsUI = answer.evaluatorsUI.concat(
                newAnswer.evaluatorsUI
              );
            } else {
              evaluation.answers.push(newAnswer);
            }
          });
        }
      });

      this.loading = false;
    }
  }

  evaluatorFormatter(evaluators: Array<User>) {
    if (evaluators.length > 1) {
      let allEvaluatorsNames = "";
      for (let i = 0; i < evaluators.length; i++) {
        if (i === evaluators.length - 1) {
          allEvaluatorsNames += ` ${evaluators[i].fullName}`;
        } else {
          allEvaluatorsNames += ` ${evaluators[i].fullName},`;
        }
      }
      return allEvaluatorsNames;
    }
    return evaluators[0].fullName;
  }

  get showEvaluators() {
    if (this.evaluationTypes && this.evaluationTypes.length > 0) {
      return this.evaluationTypes.some((x: any) =>
        x.hasOwnProperty("proporsalUsersEvaluators")
      )
        ? true
        : false;
    }
    return false;
  }
}
